import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
import axios from "axios";
export default {
  // 搜索推荐列表
  getSearchList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/queryESListHasColler",
      data,
      false
    );
  },
  // 搜索论文/资讯/专著/会议列表接口
  getEsList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-elasticsearch/search/article",
      data,
      false
    );
  },
  // 搜索图书/行业报告列表接口
  getEsTsBgList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-elasticsearch/search/goods",
      data,
      false
    );
  },
  // 搜索用户列表接口
  userList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-elasticsearch/search/user",
      data,
      false
    );
  },
  // 机构
  orgList(data) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/es/nf/orgList", data, false);
  },
  searchNav() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/dictionaries/info", {});
  },
  //
  getSideList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/industry/getOneList");
  },
  getSubList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/industry/getListByPid",
      data
    );
  },
  getIncludeList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/include/includeList");
  },
  getYearList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/year/infoPage");
  },
  // 视频
  articleVideoList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleVideo/list",
      data,
      false
    );
  },
  getSearchVideo(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleVideo/es",
      data,
      false
    );
  },
  // 首页navlist
  getNavList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/column/getKnowledgeList",
      data,
      false
    );
  },
  // 首页navList(h5)
  getKnowledgeList() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/mobileColumn/getKnowledgeList",
      {},
      false
    );
  },
  // 三方词库搜索
  getDictionary(data) {
    console.log("检索内容:", data);
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/dictionary/query",
      data,
      false
    );
  },
  // 搜索中间页获取最新消息
  getLatestNews(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/adminInfo/getnewList",
      data,
      false
    );
  },
  // 搜索综合用户结果页
  getUserSearchList(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-user/app/nf/allList", data, false);
  },
  // 搜索综合文章结果页
  getArticleSearchList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-elasticsearch/search/groupPageAll",
      data,
      false
    );
  },
};
